import './polyfills';

import('./bootstrap').catch((err) => {
    console.error('Failed to load application:', err);
});
